import styled from 'styled-components'

const Text = styled.span`
  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.text.dark.secondary};

  > b {
    color: ${({ theme }) => theme.colors.text.dark.primary};
  }
`

export default Text
